<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M4.5 11.5L10 18.5L20.5 7.5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'CheckIcon',
};
</script>
